import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const myLogsApi = createApi({
    reducerPath: "myLogsApi",
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem("token");
            if (token) {
                headers.set("authorization", `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getMyLogs: builder.query({
            query: () => ({
                url: "/WorkerLog/my-logs",
                method: "GET",
            }),
        }),
    }),
});

export const { useGetMyLogsQuery } = myLogsApi;
